import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationDialogModel } from './confirmation-dialog.model';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';

@Injectable()
export class ConfirmationDialogService {

  constructor(private dialog: MatDialog) {
  }

  show(data: ConfirmationDialogModel) {
    const size = data.size === null ? '534px' : data.size;

    return this.dialog
      .open(ConfirmationDialogComponent, {
        data,
        width: size
      })
      .afterClosed();
  }
}
